import { request, METHOD } from '../utils/request.js'




export function getFinishProject (obj) {
  return request(
    '/h5Mfitness/parent/getFinishProject',
    METHOD.POST,
    obj
  )
}
export function getTermInfoList (obj) {
  return request(
    '/iot/h5fitness/fitnessAchievementActivity/getTermInfoList',
    METHOD.POST,
    obj
  )
}
export function querySingleFitnessEvaluationAnalysis (obj) {
  return request(
    '/h5Mfitness/parent/querySingleFitnessEvaluationAnalysis',
    METHOD.GET,
    obj
  )
}
export function queryPhysicalFitnessAnalysis (obj) {
  return request(
    '/h5Mfitness/parent/queryPhysicalFitnessAnalysis',
    METHOD.GET,
    obj
  )
}




export function queryPhysicalQualityAnalysis (obj) {
  return request(
    '/h5Mfitness/parent/queryPhysicalQualityAnalysisBody',
    METHOD.GET,
    obj
  )
}
export function queryPhysicalIntensityAnalysis (obj) {
  return request(
    '/h5Mfitness/parent/queryPhysicalIntensityAnalysis',
    METHOD.GET,
    obj
  )
}
export function queryPortraitData (obj) {
  return request(
    '/h5Mfitness/parent/queryPortraitData',
    METHOD.GET,
    obj
  )
}
export function getAdditionalProject (obj) {
  return request(
    '/iot/h5fitness/fitnessAchievementActivity/getAdditionalProject',
    METHOD.POST,
    obj
  )
}
export function queryTestRecord (obj) {
  return request(
    '/iot/h5fitness/fitnessAchievementActivity/queryTestRecord',
    METHOD.POST,
    obj
  )
}
export function querySingleAnalysis (obj) {
  return request(
    '/iot/h5fitness/fitnessAchievementActivity/querySingleAnalysis',
    METHOD.GET,
    obj
  )
}


// 查看总分
export function scoreStaBySnCode (obj) {
  return request(
    '/h5Mfitness/com/scoreStaBySnCode',
    METHOD.POST,
    obj
  )
}
// 查看个人报告
export function finalScoreList (obj) {
  return request(
    '/h5Mfitness/com/finalScoreList',
    METHOD.POST,
    obj
  )
}

// 查体测记录新
export function getScoreListOnlyActivity (obj) {
  return request(
    'h5Mfitness/newH5Fitness/getScoreListOnlyActivity',
    METHOD.POST,
    obj
  )
}



// 测试记录
export function getFitnessTestBySnCode(obj) {
  return request(
    '/h5Mfitness/com/getFitnessTestBySnCode',
    METHOD.POST,
    obj
  )
}


// 六边形
export function getNewFitnessScoreList (obj) {
  return request(
    'h5Mfitness/com/getNewFitnessScoreList',
    METHOD.POST,
    obj
  )
}


// 区间
export function queryPhysicalQualityAnalysiscom (obj) {
  return request(
    'h5Mfitness/com/queryPhysicalQualityAnalysis',
    METHOD.GET,
    obj
  )
}